<template>
  <div class="products">
    <div class="product-top">
      <div class="condition-line1 ">
         <p></p>
        <div class="condition-line1-title">贷款类型</div>
        <div class="condition-line-flex">
          <div v-for="(item, idx) in loanTypeList" :key="item.id" @click="changeLoanType(idx, item)"
            :class="{ 'selected': selectLoanType == idx }">
            <span class="loan-type">{{ item.dictionaryKey }}</span>
          </div>
        </div>

      </div>
      <div class="condition-line1">
         <p></p>
        <div class="condition-line1-title">担保类型</div>
        <div v-for="(item, idx) in assureTypeList" :key="item.id" @click="changeAssureType(idx, item)"
          :class="{ 'selected': selectAssureType == idx }">
          <span>{{ item.dictionaryKey }}</span>
        </div>
      </div>
      <div class="condition-line1">
         <p></p>
        <div class="condition-line1-title">利率范围</div>
        <div v-for="(item, idx) in rateList" :key="item.idx" @click="changeRate(idx, item)"
          :class="{ 'selected': selectRate == idx }">
          <span v-if="!item.zxdklv && !item.zddklv">不限</span>
          <span v-else-if="item.zxdklv && item.zddklv">{{ item.zxdklv }}%—{{ item.zddklv }}%</span>
          <span v-else-if="item.zddklv">{{ item.zddklv }}%以下</span>
          <span v-else-if="item.zxdklv">{{ item.zxdklv }}%以上</span>
        </div>
      </div>
      <div class="condition-line1">
         <p></p>
        <div class="condition-line1-title">贷款期限</div>
        <div v-for="(item, idx) in monthList" :key="item.idx" @click="changeMonth(idx, item)"
          :class="{ 'selected': selectMonth == idx }">
          <span v-if="!item.dkqxxx && !item.dkqxsx">不限</span>
          <span v-else-if="item.dkqxxx && item.dkqxsx">{{ item.dkqxxx }}—{{ item.dkqxsx }}个月</span>
          <span v-else-if="item.dkqxsx">{{ item.dkqxsx }}个月及以下</span>
          <span v-else-if="item.dkqxxx">{{ item.dkqxxx }}个月及以上</span>
        </div>
      </div>
      <div class="condition-line1">
         <p></p>
        <div class="condition-line1-title">贷款额度</div>
        <div v-for="(item, idx) in atmList" :key="item.idx" @click="changeAmt(idx, item)"
          :class="{ 'selected': selectAmt == idx }">
          <span v-if="!item.dkedxx && !item.dkedsx">不限</span>
          <span v-else-if="item.dkedxx && item.dkedsx">{{ item.dkedxx }}—{{ item.dkedsx }}万</span>
          <span v-else-if="item.dkedsx">{{ item.dkedsx }}万以下</span>
          <span v-else-if="item.dkedxx">{{ item.dkedxx }}万以上</span>
        </div>
      </div>
    </div>
    <div class="product-list">
      <div class="searchBox">
        <div style="height: 50px;line-height: 25px; padding: 0 25px;font-size: 14px;">总数：<span
            style="color: #ff1e00; font-size: 16px; font-weight: 600;">{{ pagination.total }}</span> {{ ' 个' }}</div>
        <div class="search-input-content">
          <el-input v-model="search.cpmc" placeholder="请输入产品名称或企业名称" clearable size="small" class="search-input"
            @keyup.enter.native="getProductArr()" @clear="clearSearch">
          </el-input>
          <i class="el-icon-search search-icon" style="padding: 8px 10px 0 3px;" @click="getProductArr()"></i>
        </div>
      </div>
      <div class="dataNull" v-if="(productList.length == 0)">
        <!-- 无数据... -->
        <div class="imgNull"></div>
      </div>
      <div class="product-item" v-for="item in productList" :key="item.id" @click="goDetail(item.id)">
         <div class="produt-left">
          <img
            src="@/assets/img/2026/house.png"
          >
        </div>
        <div class="produt-middle">
          <div class="mid-line2">
            <div class="line2-item">
              <span class="orange">{{ item.cpmc }}</span>
              <span class="textJ">{{ item.qymc }}</span>
            </div>
            <div class="line2-item">
              <span class="orange" v-if="item.zxdklv && item.zddklv">{{ item.zxdklv }}%—{{ item.zddklv }}%</span>
              <span class="orange" v-else-if="item.zddklv">{{ item.zddklv }}%以下</span>
              <span class="orange" v-else-if="item.zxdklv">{{ item.zxdklv }}%以上</span>
              <span>年化利率范围</span>
            </div>
            <div class="line2-item">
              <span class="orange" v-if="item.dkqx && item.dkqx">{{ item.dkqx }}个月</span>
              <span>贷款期限</span>
            </div>
            <div class="line2-item">
              <span class="orange" v-if="item.dked && item.dked">{{ item.dked }}万</span>
              <span>贷款额度</span>
            </div>
            <div class="line2-item">
              <span class="orange">{{ item.dbfs }}</span>
              <span>担保方式</span>
            </div>
          </div>
        </div>
        <div class="product-right">
          <div class="produt-right-button" @click.stop="goDetail(item.id)">详细信息</div>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination layout="total, sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="pagination.page" :page-size.sync="pagination.size" :total="pagination.total"
        @current-change="getProductArr" @size-change="queryData" />
    </div>
  </div>
</template>
<script>
import { dataKeyMap } from '@/utils/constant'
import imageView from ".././imageView.vue";
import editDialog from "./components/editDialog";
import { getDictionaryKeys, getNeedstList } from "@/api";
export default {
  name: "Products",
  components: { imageView, editDialog },
  data() {
    return {
      userInfoweb: this.$store.state.system.userInfoweb,
      token: this.$store.state.system.token,
      inputVal: "",
      dictionary: {
        guaranty: dataKeyMap.guaranty, // 担保方式
        loan: dataKeyMap.loan, // 贷款类型
      },
      loanTypeList: [],
      assureTypeList: [],
      selectLoanType: 0,
      selectAssureType: 0,
      selectRate: 0,
      selectMonth: 0,
      selectAmt: 0,
      search: {
        cpmc: "",//产品名称
        dbfsc: "",//担保方式编码
        dklxc: "",//贷款类型编码
        dkqxxx: "",//贷款期限下线
        dkqxsx: "",//贷款期限上线
        dkedxx: "",//贷款额度下线
        dkedsx: "",//贷款额度上线
        zxdklv: "",//贷款利率下线
        zddklv: "",//贷款利率下线
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      rateList: [
        { idx: 0, zxdklv: "", zddklv: "" },
        { idx: 1, zxdklv: "", zddklv: "5" },
        { idx: 2, zxdklv: "5", zddklv: "8" },
        { idx: 3, zxdklv: "8", zddklv: "12" },
        { idx: 4, zxdklv: "12", zddklv: "" },
      ],
      monthList: [
        { idx: 0, dkqxxx: "", dkqxsx: "" },
        { idx: 1, dkqxxx: "", dkqxsx: "6" },
        { idx: 2, dkqxxx: "6", dkqxsx: "12" },
        { idx: 3, dkqxxx: "12", dkqxsx: "36" },
        { idx: 4, dkqxxx: "36", dkqxsx: "" },
      ],
      atmList: [
        { idx: 0, dkedxx: "", dkedsx: "" },
        { idx: 1, dkedxx: "", dkedsx: "100" },
        { idx: 2, dkedxx: "100", dkedsx: "200" },
        { idx: 3, dkedxx: "200", dkedsx: "500" },
        { idx: 4, dkedxx: "500", dkedsx: "1000" },
        { idx: 5, dkedxx: "1000", dkedsx: "" },
      ],
      productList: [],
    }
  },
  created() {
  },
  mounted() {
    this.getDataList();
    this.queryData();
  },
  methods: {
    clearSearch() {
      this.search.cpmc = "";
      this.getProductArr();
    },
    getDataList() {
      const assureTypeKey = this.dictionary.guaranty;
      const loanTypeKey = this.dictionary.loan;
      if (assureTypeKey) {
        getDictionaryKeys([assureTypeKey, loanTypeKey]).then((res) => {
          this.assureTypeList = [{ dictionaryKey: "不限", code: "", id: 0 }].concat(res.data[assureTypeKey].children);
          this.loanTypeList = [{ dictionaryKey: "不限", code: "", id: 0 }].concat(res.data[loanTypeKey].children);
        });
      }
    },
    goDetail(id) {
      if(this.token&&this.userInfoweb&&(this.userInfoweb.type==5)){
        this.$router.push('/needs/NeedsDetail/' + id);
      }else{
          this.$confirm('是否登录金融机构账号？', '', {
            confirmButtonText: '登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              name: 'login',
              query: {
                type: 2,
              },
            });
          }).catch(() => {
          });
      }
    },
    changeLoanType(idx, item) {
      this.selectLoanType = idx;
      this.search.dklxc = item.code;
      this.queryData();
    },
    changeAssureType(idx, item) {
      this.selectAssureType = idx;
      this.search.dbfsc = item.code;
      this.queryData();
    },
    changeRate(idx, item) {
      this.selectRate = idx;
      this.search.zxdklv = item.zxdklv;
      this.search.zddklv = item.zddklv;
      this.queryData();
    },
    changeMonth(idx, item) {
      this.selectMonth = idx;
      this.search.dkqxxx = item.dkqxxx;
      this.search.dkqxsx = item.dkqxsx;
      this.queryData();
    },
    changeAmt(idx, item) {
      this.selectAmt = idx;
      this.search.dkedxx = item.dkedxx;
      this.search.dkedsx = item.dkedsx;
      this.queryData();
    },

    getProductArr() {
      getNeedstList({
        ...this.search,
        current: this.pagination.page,
        size: this.pagination.size,
      })
        .then((res) => {
          if (res.code === 1000) {
            this.productList = res.data.records
            this.pagination.total = res.data.total
          } else {
            this.$baseMessage(res.message, 'error')
          }
        })
        .catch((err) => {
          this.loading = false
        })
    },
    queryData() {
      this.pagination.page = 1;
      this.getProductArr();
    },   //产品详情
  },
}
</script>
<style lang="scss" scoped>
.products{
  padding: 28px 0px 20px 0px; 
 width:1500px;
 margin: 0 auto;
}
.product-top{
  padding:10px 30px 10px 30px;margin-bottom:15px; 
  border-radius: 16px; 
   background-color: rgb(255, 255, 255);
}
.financing-search {
  padding: 40px 0;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  background: #f3f7fb;
}

.financing-search-condition {
  font-size: 18px;
}

.condition-line {
  margin-top: 25px;
  text-align: left;
  color: #727272;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.condition-line1 {
  margin: 35px 0;
    text-align: left;
    color: #727272;
    width: 100%;
    display: flex;
    align-items: center;
   p{
    width: 3px;
    height:35px;
    background-color: #2a66e7;
    margin-right: 10px;
  }
}

.condition-line1-title {
  color: black;
  font-weight: bold;
  font-size: 19px;
}

.condition-line1 div {
  display: inline;
  margin-right: 36px;
  cursor: pointer;
}

.selected span {
  text-align: center;
  color: white;
  background-color: #2a66e7;
  padding: 7px 30px;
  margin: 0 -10px;
  border-radius: 16px;
}

.searchBox {
  /* height: 50px;
  width: 100%;
  border-bottom: 1px solid #eee;
  */

  padding: 9px 0;
  /* background: #fff; */
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  margin-top: 7px;
  margin-right: 30px;
  border-bottom: 1px solid #eee;

}

.search-input-content {
  display: flex;
  justify-content: space-between;
  width: 280px;
  height: 34px;
  margin-right: 30px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #d2d2d2;
}

.search-input {
  width: 260px;
  height: 30px;
  margin-left: 10px;
}

::v-deep .search-input .el-input__inner {
  border: 0px;
}

.dataNull {
  height: 200px;
  line-height: 100px;
  width: 100%;
  text-align: center;
  color: #969696;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.imgNull {
  width: 199px;
  height: 199px;
  background-image: url("~@/assets/img/dataNull.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: auto;
  padding: 25px 0;
}

.product-item {
  height: 170px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 15px 0;
  padding: 15px 30px;
  background-color: #fff;
  border-radius: 16px;
  cursor: pointer;
}

.product-item:hover {
  box-shadow: 0px 0px 8px #2a66e7;
}

.product-list>div:nth-child(2) {
  margin: 0 !important;
}

.product-item:nth-last-child(1) {
  margin: 15px 0 5px 0 !important;
  border-bottom: 1px solid #eee;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.produt-left {
  display: inline-flex;
  height: 140px;
  width: 14%;
}

.produt-left img {
  margin: auto 0;
  width: 130px;
  height: 130px;
}

.produt-middle {
  display: inline-block;
  height: 140px;
  width: 70%;
  padding-right: 20px;
}

.mid-line1 {
  height: 20px;
  line-height: 20px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}

.mid-line2 {
  display: inline-flex;
  justify-content: space-between;
  font-size: 18px;
  width: 100%;
  margin: 30px 0;
}

.line2-item {
  display: inline-flex;
  flex-direction: column;
  justify-content: space-around;
}

.line2-item:nth-child(1) .orange {
  color: #000;
  text-align: start;
}

.line2-item:nth-child(1) .textJ {
  color: #000;
  text-align: start;
  font-size: 15px;
}

.line2-item span {
  display: block;
  text-align: center;
  height: 40px;
  line-height: 40px;
}

.orange {
    color: #2a66e7;
  font-weight: bold;
}

.product-right {
  width: 14%;
  height: 95px;
  padding: 25px;
}

.produt-right-button {
  color: #2a66e7;
  width: 110px;
  padding: 8px 10px;
  margin: 30px 0;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #2a66e7;
}

.produt-right-button:hover {
  color: #fff;
  background: #2a66e7;
}

.page {
  padding: 10px 10px;
  height: 50px;
  /* background-color: #fff; */
  text-align: right;
}

@media screen and (max-width: 767px) {
  .list-item div {
    padding: 30px;
  }
}


.productCom {
  position: fixed;
  height: 100vh;
  width: 300px;
  top: 0px;
  right: -300px;
  z-index: 999;
  background-color: #fff;
  box-shadow: -12px 0px 12px 0px rgba(0, 0, 0, 0.1)
}

.productComShow {
  right: 0px;
  transition: all .3s ease-in;
}

.productComHide {
  right: -300px;
  transition: all .3s ease-in;
}

.productCom .titlle {
  height: 35px;
  width: 100%;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.productCom h2 {
  width: 255px;
  font-size: 15px;
  color: #333;
  display: inline-block;
  font-weight: 600;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 8px 5px;
}

.productCom .el-icon-close {
  display: inline-block;
  font-size: 25px;
  padding-top: 3px;
}

.productCom .product-ul li {
  height: 100px;
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #dddddd;
}

.productCom .product-ul li .pTitle {
  height: 25px;
  padding-left: 20px;
}

.productCom .product-ul li .pTitle .pName {
  font-size: 15px;
  font-weight: 600;
  width: 240px;
  height: 25px;
  line-height: 25px;
  display: inline-block;
}

.productCom .product-ul li .pTitle .pName:hover {
  color: #2a66e7;
}

.productCom .product-ul li .pTitle .el-icon-close {
  height: 25px;
  font-size: 19px;
  display: inline-block;
}

.productCom .product-ul li .pContent {
  width: 300px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productCom .product-ul li .pContent .content1 {
  height: 50px;
  width: 83px;
  margin: auto;
}

.productCom .product-ul li .pContent .content1 .text1 {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}

.productCom .product-ul li .pContent .content1 .text2 {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #999;
}
</style>

